import AutoStoriesOutlinedIcon from "@mui/icons-material/AutoStoriesOutlined";
import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";
import RocketLaunchOutlinedIcon from "@mui/icons-material/RocketLaunchOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import GppGoodOutlinedIcon from "@mui/icons-material/GppGoodOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import PsychologyOutlinedIcon from "@mui/icons-material/PsychologyOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import SubjectOutlinedIcon from "@mui/icons-material/SubjectOutlined";

export const NAV_GROUPS = [
  {
    label: "Setup",
    tabs: [
      {
        id: "instructions",
        label: "Instructions",
        icon: SubjectOutlinedIcon,
      },
      {
        id: "model",
        label: "Model",
        icon: PsychologyOutlinedIcon,
        systemAgentVisible: true,
      },
      {
        id: "cost",
        label: "Operating cost",
        icon: PaymentsOutlinedIcon,
        systemAgentVisible: true,
      },
    ],
  },
  {
    label: "Capabilities",
    tabs: [
      {
        id: "tools",
        label: "Tools",
        icon: BuildOutlinedIcon,
      },
      {
        id: "knowledge",
        label: "Knowledge",
        icon: MenuBookOutlinedIcon,
      },
      {
        id: "skills",
        label: "Skills",
        icon: AutoStoriesOutlinedIcon,
      },
      {
        id: "approvalPolicies",
        label: "Approval policies",
        icon: GppGoodOutlinedIcon,
        hideForSystemAgent: true,
      },
      {
        id: "validation",
        label: "Output validation",
        icon: FactCheckOutlinedIcon,
      },
      {
        id: "harness",
        label: "Self-driving harness",
        icon: RocketLaunchOutlinedIcon,
        hideForSystemAgent: true,
      },
    ],
  },
  {
    label: "Channels",
    tabs: [
      {
        id: "publicChat",
        label: "Public chat",
        icon: ShareOutlinedIcon,
      },
      {
        id: "email",
        label: "Email",
        icon: EmailOutlinedIcon,
      },
    ],
  },
  {
    label: "Advanced",
    tabs: [
      {
        id: "advanced",
        label: "Advanced",
        icon: SettingsOutlinedIcon,
      },
    ],
  },
];

export const NAV_TABS = NAV_GROUPS.flatMap((group) => group.tabs);
